export default "__VITE_ASSET__68a0604f__"